import { ImageDown, Ratio } from 'lucide-react'
import { ExportPanel } from '@/tools/output/ExportPanel'
import { FormatPanel } from '@/tools/output/FormatPanel'
import { ToolKind, ToolTab, type OutputTool } from '@/tools/types'

export const FORMAT_TOOL: OutputTool = {
  kind: ToolKind.Output,
  tab: ToolTab.Format,
  label: 'Format',
  icon: Ratio,
  appliesTo: () => true,
  Panel: FormatPanel,
}

export const EXPORT_TOOL: OutputTool = {
  kind: ToolKind.Output,
  tab: ToolTab.Export,
  label: 'Export',
  icon: ImageDown,
  appliesTo: () => true,
  Panel: ExportPanel,
}
